import { render, staticRenderFns } from "./MchPayConfigAddOrEdit.vue?vue&type=template&id=28ab351e&scoped=true"
import script from "./MchPayConfigAddOrEdit.vue?vue&type=script&lang=js"
export * from "./MchPayConfigAddOrEdit.vue?vue&type=script&lang=js"
import style0 from "./MchPayConfigAddOrEdit.vue?vue&type=style&index=0&id=28ab351e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ab351e",
  null
  
)

export default component.exports